import { Box, Flex, MenuItem, Text } from '@chakra-ui/react'
import { FaRegStar, FaStar } from 'react-icons/fa'
import { IoIosRemoveCircle } from 'react-icons/io'

const TableProfileMenuItem = ({
  name,
  handleSelectProfile,
  handleSetDefaultProfile,
  handleEdit,
  isSelected = false,
  needSave = false,
  isDefault = false,
}) => {
  return (
    <MenuItem
      bg={isSelected ? 'teal.500' : 'white'}
      color={isSelected ? 'white' : 'black'}
      onClick={handleSelectProfile}
      icon={
        isDefault ? (
          <FaStar size="15" color={'#ECC94B'} />
        ) : (
          <Box _hover={{ color: 'yellow' }} onClick={handleSetDefaultProfile}>
            <FaRegStar size="15" />
          </Box>
        )
      }
      _hover={{ bg: isSelected ? 'teal.500' : 'teal.600', color: 'white' }}
    >
      <Flex gap="3" alignItems={'center'} justifyContent={'space-between'}>
        <Text>
          {name}
          {needSave ? '*' : ''}
        </Text>
      </Flex>
    </MenuItem>
  )
}

export default TableProfileMenuItem
